export const projectsData = [
    {
        name: 'DOG WIKI',
        linkApp: 'https://dogswiki.up.railway.app/',
        gitHub: 'https://github.com/SrDevDash/PI-Dogs-main',
        previewImg: 'https://user-images.githubusercontent.com/62898809/216082786-dbec28af-a805-413b-b764-adfd6ed02e9d.png'
    },
    {
        name: 'Rick And Morty',
        linkApp: 'https://srdashrickandmorty.netlify.app/',
        gitHub: 'https://github.com/SrDevDash/RickMortyApp',
        previewImg: 'https://cdn.computerhoy.com/sites/navi.axelspringer.es/public/media/image/2021/06/rick-morty-2381623.jpg'
    },
    {
        name: 'Ingreso Egreso',
        linkApp: 'https://ingreso-egresov2.web.app/',
        gitHub: 'https://github.com/SrDevDash/Ingreso-EgresoAppV2',
        previewImg: 'https://user-images.githubusercontent.com/62898809/216083556-6a4f4c8c-f128-4c2d-96b9-47f73e7abd1b.png'
    },
    {
        name: 'PokeDex',
        linkApp: 'https://segundaapp-3403b.web.app/',
        gitHub: 'https://github.com/SrDevDash/PokeDexApp',
        previewImg: 'https://user-images.githubusercontent.com/62898809/201666075-536b0840-7260-43c7-bd31-2c299fa87a26.png'
    },
]

